import React from "react";
import PropTypes from "prop-types";

import EditContainer from "../layouts/edit-container";
import Panel from "../reader/panel";
import Isvg from "../../../vendor/react-inlinesvg";

class Feedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedButton: null,
      isCommentHidden: true,
      comment: "",
      isInterestedInTesting: false
    };

    this._feedbackButtonClick = this._feedbackButtonClick.bind(this);
    this._tellUsMoreClick = this._tellUsMoreClick.bind(this);
    this._updateLocation = this._updateLocation.bind(this);
    this._textAreaChange = this._textAreaChange.bind(this);
    this._testingInputChange = this._testingInputChange.bind(this);
    this._closeModal = this._closeModal.bind(this);
    this._submitHandler = this._submitHandler.bind(this);
    this._getFeedbackMetric = this._getFeedbackMetric.bind(this);
  }

  _feedbackButtonClick(e) {
    const index = $(e.target).attr("data-button-number");
    // Show the comment box only if user doesn't click 9 or 10
    const isCommentHidden =
      parseInt(index, 10) === 9 || parseInt(index, 10) === 10;

    this.setState(
      {
        isCommentHidden,
        selectedButton: index
      },
      () => {
        // Adjust position of popup if it changes due to opening comment box
        Fraction.Helpers.runAfterRender(() => this._updateLocation());
        // Need previous update to complete before actually going to bottom,
        // so separate wrapper is required
        Fraction.Helpers.runAfterRender(() => {
          const box = $(".modal-box");
          // Set to scroll bottom on mobile
          box[0].scrollTop = box[0].scrollHeight;
        });
      }
    );
  }

  _tellUsMoreClick(e) {
    this.setState(state => ({ isCommentHidden: !state.isCommentHidden }));
    this._updateLocation();
  }

  _updateLocation() {
    // Need to call modal update to adjust position after showing/hiding comment box
    // Wrap in setTimeout to make sure it runs after state render
    Fraction.Helpers.runAfterRender(() =>
      Fraction.Helpers.updateModalLocation()
    );
  }

  _textAreaChange(e) {
    this.setState({
      comment: e.target.value
    });
  }

  _testingInputChange(e) {
    this.setState({
      isInterestedInTesting: e.target.checked
    });
  }

  _closeModal() {
    Fraction.Helpers.removeModal();
  }

  _submitHandler(e) {
    e.preventDefault();
    // Make a deep copy of this.state and then format data for submission to Google sheet
    const submissionData = JSON.parse(JSON.stringify(this.state));
    delete submissionData.isCommentHidden;

    // Convert to format google sheet can accept
    submissionData.selectedButton =
      parseInt(submissionData.selectedButton, 10) || null;
    submissionData.comment = submissionData.comment || null;

    if (submissionData.isInterestedInTesting) {
      submissionData.isInterestedInTesting = "Yes";
    } else {
      submissionData.isInterestedInTesting = "No";
    }

    const feedbackMetric = this._getFeedbackMetric();

    $.ajax({
      url:
        "https://docs.google.com/forms/d/1zhoDHLC7b6-Icy_4KUeJM9SmDzwU4K2DFKVNePdaaGA/formResponse",
      type: "POST",
      data: {
        "entry.1809465886": Fraction.User.email.hashMe(), // user email
        "entry.1320916557": submissionData.selectedButton, // number
        "entry.1261714228": submissionData.comment, // comment
        "entry.1296811082": brands.brand_name, // brand
        "entry.693405805": navigator.userAgent, // user agent
        "entry.856330944": $(window).width(), // screen width
        "entry.1678736001": submissionData.isInterestedInTesting, // interested in review
        "entry.1833463679": feedbackMetric // which trigger caused popup to appear
      }
    });

    Fraction.Helpers.removeModal();
    Fraction.Helpers.toast(i18n.t("feedback.thank-you"));
  }

  _getFeedbackMetric() {
    // It's rare but possible to have 2 triggers for popup, so build a string
    // based on which metric triggered the NPS popup
    const suffix = "-" + Fraction.User.email.hashMe().toString();
    const obj = Fraction.Helpers.getDataObject("User.Persist")[
      "NPSLog" + suffix
    ];

    let feedbackMetric = "";

    if (obj["page-views"] >= 100) {
      feedbackMetric += " page-views";
    }
    if (obj.highlights >= 40) {
      feedbackMetric += " highlights";
    }
    if (obj.notes >= 10) {
      feedbackMetric += " notes";
    }
    if (obj.searches >= 20) {
      feedbackMetric += " searches";
    }
    if (obj["search-clicks"] >= 20) {
      feedbackMetric += " search-clicks";
    }
    if (obj.logins >= 15) {
      feedbackMetric += " logins";
    }

    if (Fraction.User.debugMenuOpened) {
      feedbackMetric += " debug";
    }

    return feedbackMetric.trim();
  }

  renderButtons(isMobile, numOfButtons = 10) {
    const buttons = [];
    for (let label = 1; label <= numOfButtons; label++) {
      const selected = {};
      let buttonClass = "feedback-button";
      if (label === parseInt(this.state.selectedButton, 10)) {
        buttonClass += " selected";
      }
      if (isMobile) {
        buttonClass += " mobile";
      }
      buttons.push({
        label,
        selected,
        buttonClass
      });
    }

    const elements = buttons.map(button => (
      <button
        onClick={this._feedbackButtonClick}
        className={button.buttonClass}
        data-button-number={button.label}
        data-selected-button={button.label === this.state.selectedButton}
        aria-pressed={this.state.selectedButton}
        key={button.label}
        type="button"
      >
        {button.label}
      </button>
    ));
    return isMobile ? elements.reverse() : elements;
  }

  render() {
    const commentStyle = {};
    if (this.state.isCommentHidden) {
      commentStyle.display = "none";
    }

    let howLikelyString;
    if (Fraction.User.ssoOnly) {
      // Need to strip comma and capitalize first letter
      howLikelyString = i18n
        .t("feedback.how-likely")
        .replace(",", "")
        .trim()
        .capitalizeFirst();
    } else {
      howLikelyString = Fraction.User.firstName + i18n.t("feedback.how-likely");
    }

    return (
      <form onSubmit={this._submitHandler}>
        <h2>{i18n.t("feedback.help-improve")}</h2>
        <p>{howLikelyString}</p>
        <div className="feedback-button-container">{this.renderButtons()}</div>

        <div className="likeliness-labels">
          {/* Spans are repeated since they are reversed on mobile */}
          <span className="feedback-likely">{i18n.t("feedback.unlikely")}</span>
          <span className="feedback-likely mobile">
            {i18n.t("feedback.likely")}
          </span>
          {this.renderButtons(true)}
          <span className="feedback-likely mobile">
            {i18n.t("feedback.unlikely")}
          </span>
          <span className="feedback-likely">{i18n.t("feedback.likely")}</span>
        </div>

        <button
          className="tell-us-more noButton"
          onClick={this._tellUsMoreClick}
          type="button"
        >
          <span>{i18n.t("feedback.tell-us-more")}</span>
          <span>
            <Isvg src="/img/down_arrow.svg" />
          </span>
        </button>

        <p className="left-align" style={commentStyle}>
          {i18n.t("feedback.more-likely", { brandName: Fraction.Brand.brand })}
        </p>

        <label htmlFor="feedback-comment">
          {i18n.t("feedback.tell-us-more")}
        </label>
        <textarea
          id="feedback-comment"
          style={commentStyle}
          onChange={this._textAreaChange}
          maxLength="2048"
        />

        <div>
          <div className="testing-container legacy-checkboxes">
            <input
              type="checkbox"
              id="product-testing-input"
              onChange={this._testingInputChange}
            />
            <label htmlFor="product-testing-input">
              {i18n.t("feedback.interested")}
            </label>
          </div>
          <div className="submit-container">
            <button type="button" onClick={this._closeModal}>
              {i18n.t("base.cancel")}
            </button>
            <button type="submit">{i18n.t("base.submit")}</button>
          </div>
        </div>
      </form>
    );
  }
}

Feedback.propTypes = {};

Feedback.defaultProps = {};

const showFeedback = function(refocusDOM, force) {
  let timeout;
  if (Fraction.Brand.Feedback.enabled || Fraction.Brand.Feedback.custom) {
    // Why do we need a timeout?  Because fraction will redirect
    // if not signed in and proactively use it's onboarding :'(
    timeout = setTimeout(() => {
      if (Fraction.User) {
        Fraction.Helpers.showModal(
          {
            content: <Feedback />,
            closeCallback: function() {},
            buttons: [],
            fullscreen: false,
            definingClass: "feedback-modal",
            intersitial: false,
            width: 667
          },
          refocusDOM,
          false
        );
      }
    }, 1400);
  }
  return timeout;
};

export default showFeedback;
